var React = require('react');

function TenCovesIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":".35","fill":"#2C4767","fillRule":"evenodd"},[React.createElement("path",{"d":"M125.438 359.075H0l184.303-185.203L11.109.002h125.269l128.925 129.263L62.297 333.03h52.256l78.525-78.61h36.703L125.438 359.076zm76.921-203.344l26.353-26.494-103.246-103.19H73.434L202.36 155.73z","key":0}),React.createElement("path",{"d":"M368.139 359.072L228.977 218.531l192.29-192.487h-52.256l-67.753 67.303h-37.013L358.127 0h125.438L310.117 173.925l183.46 185.147H368.139zm-76.584-166.556l-25.903 25.959 113.372 114.553h52.284L291.555 192.516z","key":1})]));
}

TenCovesIcon.defaultProps = {"width":"494","height":"360","viewBox":"0 0 494 360"};

module.exports = TenCovesIcon;

TenCovesIcon.default = TenCovesIcon;
